import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import "./style.css";
import { getOrders } from "../../../../api/orders";

import { callChatGTP, IconIA } from "../../../../api/ia";
import { setAlert } from "../../../../reducers/userConfigSlice";
import { useSelector } from "react-redux";

export const Asistente = () => {
  const dispatch = useDispatch();
  const corporationId = useSelector(
    (state) =>
      state.aplicationConfig.corporationData.info.corporation.corporationId
  );
  const [messages, updateMessages] = useState([]);
  const [corporationDataOrders, setCorporationDataOrders] = useState([]);
  const scrollRef = useRef(null);

  const getLastOrders = (arr, orders = 15) => {
    return arr.slice(0, orders);
  };

  const getCorporationData = async () => {
    const responseOrders = await getOrders();
    if (responseOrders && !responseOrders.error) {
      const response = responseOrders.data.orders.map((order) => {
        return {
          number: order.number,
          customer: order.Customer.fullname,
          createdAt: order.createdAt,
          products: order.products,
          paymentStatus: order.paymentStatus,
          total: order.total,
        };
      });
      setCorporationDataOrders({ data: response });
    }
  };

  const handleNewMessage = (newMessage) => {
    updateMessages((prevMessages) => [...prevMessages, newMessage]);
  };

  const iaRequest = async (prompt) => {
    const promptDetailed = `Quiero que analices el siguiente array de pedidos y me digas **${prompt}**.
    📝 Condiciones:
    - **Filtra únicamente** productos cuya propiedad 'createdAt' esté dentro de los últimos 15 días respecto a la fecha actual.
    - **Agrupa por nombre** y suma la cantidad total 'total'.
    - Dame el **top 10** productos con más unidades vendidas.
    - Responde de forma clara, concisa y basada **exclusivamente** en los datos proporcionados.
    - No inventes ni rellenes información que no esté presente.
    - La respuesta debe ser resumida, clara y concisa.
    - Dame la respuesta en forma de lista.
    - Al final dame una sugerencia relacionada con la respuesta.
    📦 Array de pedidos: 
    '''json 
    ${JSON.stringify(getLastOrders(corporationDataOrders.data, 3))}`;

    handleNewMessage({ user: "client", message: prompt });

    await callChatGTP(promptDetailed)
      .then((response) => {
        handleNewMessage({ user: "ia", message: response });
      })
      .catch(() => {
        dispatch(
          setAlert({
            called: true,
            title: "Error",
            message: "Ha ocurrido un error, inténtalo de nuevo mas tarde.",
            type: "error",
          })
        );
      });
  };

  const Questions = () => {
    const questions = [
      "¿Cuántos pedidos se han realizado en los últimos 15 días y cuál es su estado actual (pendientes, completados, cancelados)?",
      "¿Qué productos han tenido más ventas durante los últimos 15 días?",
      "¿Qué clientes realizaron más compras los últimos 15 días y cuál fue el valor total de sus pedidos?",
    ];
    return (
      <div className="userMessages">
        {questions.map((question, idx) => (
          <button
            key={idx}
            className="question"
            type="button"
            onClick={() => iaRequest(question)}
            tabIndex={0}
            style={{
              background: "none",
              border: "none",
              padding: 0,
              textAlign: "left",
              width: "100%",
              cursor: "pointer",
            }}
          >
            {question}
          </button>
        ))}
      </div>
    );
  };

  const Chat = () => {
    return (
      <div className="chat" ref={scrollRef}>
        {messages.map((msg, idx) => (
          <div className={`message-${msg.user}`} key={idx}>
            {msg.user === "ia" && IconIA}
            <div
              className={`msg-${msg.user}`}
              dangerouslySetInnerHTML={{
                __html: msg.message.replace(/\n/g, "<br>"),
              }}
            />
            {msg.user === "client" && (
              <div
                className="avatar"
                style={{ paddingTop: "7px", paddingLeft: "9px" }}
              >
                <img
                  src={`https://cdn.delibran.app/corporations/${corporationId}/configuration/logo.png`}
                  alt="logo"
                  className="brandDashboard"
                  width="50px"
                />
              </div>
            )}
          </div>
        ))}
        <Questions />
      </div>
    );
  };

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]); // Se ejecuta cada vez que cambia "messages"

  useEffect(() => {
    getCorporationData();
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Chat />;
};
